<div class="app-component app-container">
  <ngx-toasta></ngx-toasta>

  <nav id="header" class="app-component navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
    <div class="container">
      <a ngPreserveWhitespaces class="app-component navbar-brand" routerLink="/">
        <img src="assets/images/logo-couleur.png" class="d-inline-block align-top" alt="logo">
        <span class="app-component appTitle">&nbsp;{{appTitle}}</span>
      </a>
      <button type="button" class="app-component navbar-toggler" data-toggle="collapse" data-target=".menuItemsContainer.app-component">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!--<div *ngIf="isUserLoggedIn" class="app-component collapse navbar-collapse menuItemsContainer">-->
      <div class="app-component collapse navbar-collapse menuItemsContainer">
        <ul class="app-component nav nav-pills flex-column flex-lg-row mr-auto">
          <!--<li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
    <a class="nav-link" routerLink="">-->
          <!--<i class="fa fa-home"></i>-->
          <!--</a>
  </li>-->
          <li class="nav-item" routerLinkActive="active">
            <a *ngIf="!isMaintenanceModeActive || isUserLoggedIn" class="nav-link" routerLink="/tableaux">{{'Tableaux d’harmonisation'}}</a>
          </li>
          <li *ngIf="!isMaintenanceModeActive || isUserLoggedIn" class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/declarations">{{'Déclaration des équivalences'}}</a>
          </li>
          <li *ngIf="canViewProducts && (!isMaintenanceModeActive || isUserLoggedIn)" class="nav-item" routerLinkActive="active" >
            <a class="nav-link" routerLink="/programmes">{{'Gestion des programmes'}}</a>
          </li>
          <!--<li class="nav-item" routerLinkActive="active" *ngIf="canViewCustomers">
    <a class="nav-link" routerLink="/customers">{{'Gestion des utilisateurs'}}</a>
  </li>-->
          <!--<li class="nav-item" routerLinkActive="active">
    <a class="nav-link" routerLink="/about">{{'xxx'}}</a>
  </li>-->

        </ul>
        <!--<ul class="app-component nav nav-pills flex-column flex-lg-row mr-md-2">
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/settings"><i class="fa fa-cog"></i></a>
          </li>
        </ul>-->
        <!--<span class="app-component navbar-text notifications-popup">{{'app.Welcome' | translate}}</span>
        <a class="app-component nav-link user-name d-inline-block px-1" [popover]="popTemplate" (onHidden)="markNotificationsAsRead()" placement="bottom" [popoverTitle]="notificationsTitle" href="javascript:;" triggers="focus">
          {{userName}}
          <span *ngIf="newNotificationCount > 0" class="badge badge-pill badge-secondary">{{newNotificationCount}}</span>
        </a>-->
        <!--<ng-template #popTemplate>
          <app-notifications-viewer [isViewOnly]="true"></app-notifications-viewer>
        </ng-template>
        <span class="app-component navbar-text">, </span>-->
        <ul class="app-component nav nav-pills ml-lg-2 flex-column flex-lg-row">
          <li class="nav-item" (click)="logout()">
            <a class="nav-link" href="javascript:;" *ngIf="isUserLoggedIn"><i class="fa fa-sign-out"></i> Déconnexion</a>
            <a class="nav-link" href="javascript:;" *ngIf="!isUserLoggedIn"><i class="fa fa-sign-in"></i> Connexion</a>
          </li>
        </ul>
      </div>
      <div *ngIf="!isUserLoggedIn && router.isActive('/about', false)" class="app-component collapse navbar-collapse menuItemsContainer">
        <ul class="app-component nav nav-pills flex-column flex-lg-row ml-auto">
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/login"><i class="fa fa-sign-in"></i></a>
          </li>
        </ul>
      </div>
      <!--<div *ngIf="!isUserLoggedIn && !router.isActive('/about', false) || false" class="app-component collapse navbar-collapse menuItemsContainer">
        <ul class="app-component nav nav-pills flex-column flex-lg-row ml-auto">
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/about"><i class="fa fa-info-circle"></i></a>
          </li>
        </ul>
      </div>-->
    </div>
  </nav>

  <div id="pre-bootstrap" *ngIf="!removePrebootScreen" [class.prebootShow.app-component]="!isAppLoaded" class="app-component prebootStep">
    <div class="messaging">
      <!--<h1>
        Loaded!
      </h1>
      <p>
        QUICK APPLICATION SYSTEM - <span style="font-style:italic">quick</span>App &copy; <a href="https://www.ebenmonney.com">WWW.EBENMONNEY.COM</a>
      </p>-->

    </div>
  </div>

  <main class="app-component container">
    <router-outlet></router-outlet>
    <div class="app-component footer-height"></div>
  </main>

  <footer class="app-component footer fixed-bottom">
    <div class="container">
      <p class="text-center text-muted">
        &copy; {{getYear()}} CEMEQ • <a href="https://www.cemeq.qc.ca" target="_blank" style="color: #17a2b8;">cemeq.qc.ca</a>
      </p>
    </div>
  </footer>

  <div *ngIf="shouldShowLoginModal" class="modal fade login-control" bsModal #loginModal="bs-modal" (onShown)="onLoginModalShown()" (onHidden)="onLoginModalHidden()" (onHide)="onLoginModalHide()"
       [config]="{backdrop: 'static'}" tabindex="-1">
    <div class="modal-dialog modal-lg h-75 d-flex flex-column justify-content-center my-0">
      <div class="modal-content">
        <div class="modal-body">
          <app-login #loginControl isModal="true"></app-login>
        </div>
      </div>
    </div>
  </div>
</div>
